import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import UsersEditContent from "../../../components/Pages/Users/Edit";

const { displayName } = config;

export default function UsersEdit(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Users Edit`;
  }, []);

  return (
    <Layout>
      <UsersEditContent />
    </Layout>
  );
}
